import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[appNoSpaces]',
    standalone: false

})
export class NoSpacesDirective {

    constructor(private el: ElementRef) {}

    @HostListener('input', ['$event'])
    onInput(event: Event): void {
        const input = event.target as HTMLInputElement;
        const cursorPosition = input.selectionStart || 0;
        const originalLength = input.value.length;

        // Remove all spaces
        input.value = input.value.replace(/\s/g, '');

        // Adjust cursor position if spaces were removed
        const newLength = input.value.length;
        const spacesRemoved = originalLength - newLength;
        const newPosition = Math.max(0, cursorPosition - spacesRemoved);

        input.setSelectionRange(newPosition, newPosition);
    }
}
